/*eslint-disable */
import React, { useState } from 'react';
import { Button, Modal, Box, Typography } from '@mui/material';

import ButtonWithLoader from "../../../../../../components/buttonWithLoader"
import { removeEmptyProperties } from "../../../../../../helpers/general"
import { getErrorsByColumnFields } from "../../bulkUsersUpload.helpers";
import { getFieldName, getErrorMessageForField } from "./warningsModal.helpers";
import { useTranslation } from 'react-i18next';

const  WarningsModal = ({ showModal, setShowModal, validationErrors=[], fileName, uploadType }) => {
 
  const errorsByColumn = getErrorsByColumnFields(validationErrors);
  const { t } = useTranslation()
  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <div>
      <Modal
        open={showModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          width: 700,
          maxHeight: 700,
          overflow: "auto",
          bgcolor: 'background.paper',
          border: "none",
          boxShadow: 24,
          p: 4,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}>
          <Typography id="modal-modal-title" variant="h5" component="h2">
            {`${t('bulk-error-column-modal-title-your')} ${fileName} ${t('bulk-error-column-modal-title')}`}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {Object.keys(removeEmptyProperties(errorsByColumn)).map((field) => {
              const fieldName = getFieldName(field, uploadType)
              const rowCount = errorsByColumn[field].length;
              const errorMessage = getErrorMessageForField(field);
              const rowsCountLabel = rowCount > 1 ? `${rowCount} ${t('bulk-error-column-rows')}`:`${rowCount} ${t('bulk-error-column-row')}`
                return(
                    <>
                        <h4>{fieldName}</h4>
                        <>
                          <span style={{color: "#eb1700", fontWeight: "bold"}}>{rowsCountLabel} </span>
                          <span> {errorMessage}</span>
                        </>
                        <p>{`${t('bulk-error-column-row-no')}: ${errorsByColumn[field].map(index => index+2).join(',')}`}</p>
                    </>
                )
            })}
          </Typography>
          <Box sx={{display: "flex", justifyContent: "end"}}>
              <ButtonWithLoader
                onClick={handleClose}
                label={t('bulk-error-column-close-modal')}
                className="primary-btn"
               />
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

export default WarningsModal;
